import { render, staticRenderFns } from "./GroupDialog.vue?vue&type=template&id=87a7d906&scoped=true"
import script from "./GroupDialog.vue?vue&type=script&lang=js"
export * from "./GroupDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupDialog.vue?vue&type=style&index=0&id=87a7d906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a7d906",
  null
  
)

export default component.exports